export default __webpack_public_path__ + "static/media/arrow-long.eb76928e.svg";